import { WallsType } from '../enums/WallsType';

export const wallsTypeMapping: Record<WallsType, string> = {
    [WallsType.UNKNOWN]: '',
    [WallsType.MONOLITH]: 'монолит',
    [WallsType.BRICK_MONOLITH]: 'кирпич-монолит',
    [WallsType.BRICK]: 'кирпич',
    [WallsType.PANEL]: 'панель',
    [WallsType.BLOCK]: 'блок',
    [WallsType.WOOD]: 'дерево'
};
